import router from "../router"
import { encodeParams } from "./pathParams"

// ----------- users tab
function openUserAdmin() {
  router.push({ name: 'adminByParams', params: { selectedTab: 'users' } })
}

function openUserAdminAndSelectUser(username) {
  const selectionParams = encodeParams({ username })
  router.push({ name: 'adminByParams2', params: { selectedTab: 'users', selectionParams } })
}

function openUserAdminAndSelectGroupAndUser(groupName, username) {
  const selectionParams = encodeParams({ groupName, username })
  router.push({ name: 'adminByParams2', params: { selectedTab: 'users', selectionParams } })
}

function openUserAdminAndSelectGroup(groupName) {
  const selectionParams = encodeParams({ groupName, username: null })
  router.push({ name: 'adminByParams2', params: { selectedTab: 'users', selectionParams } })
}

// -----------  groups tab
function openGroupAdmin() {
  router.push({ name: 'adminByParams', params: { selectedTab: 'groups' } })
}

function openGroupAdminAndSelectGroup(groupName) {
  const selectionParams = encodeParams({ groupName })
  router.push({ name: 'adminByParams2', params: { selectedTab: 'groups', selectionParams } })
}

// -----------  roles tab
function openRoleAdmin() {
  router.push({ name: 'adminByParams', params: { selectedTab: 'roles' } })
}

function openRoleAdminAndSelectRole(rolename) {
  const selectionParams = encodeParams({ rolename })
  router.push({ name: 'adminByParams2', params: { selectedTab: 'roles', selectionParams } })
}

export { 
  openUserAdmin, 
  openUserAdminAndSelectUser,
  openUserAdminAndSelectGroupAndUser,
  openUserAdminAndSelectGroup,
  openGroupAdmin,
  openGroupAdminAndSelectGroup,
  openRoleAdmin,
  openRoleAdminAndSelectRole,
}